export default (hoverEffect = 'zoom') => ({
  hoverEffect: hoverEffect,

  init() {
    if (hoverEffect === 'none') return

    const items = this.$el.querySelectorAll('[data-index]')

    items.forEach((item, index) => {
      item.style.opacity = '0'
      item.style.transform = 'translateY(20px)'
      item.style.transition = 'opacity 0.6s ease-out, transform 0.6s ease-out'
    })

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.dataset.index)
            const delay = (index - 1) * 100

            setTimeout(() => {
              entry.target.style.opacity = '1'
              entry.target.style.transform = 'translateY(0)'
            }, delay)

            observer.unobserve(entry.target)
          }
        })
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
    )

    items.forEach((item) => {
      observer.observe(item)
    })

    this.$el._cleanup = () => {
      observer.disconnect()
    }
  },

  destroy() {
    if (this.$el._cleanup) {
      this.$el._cleanup()
    }
  }
})
